export default __webpack_public_path__ + "static/media/hero-video-safari-pt.84ce0fdf.mp4";